// Catalog state keyed by store_id. See memory: project_catalog_reducer.md
//
// Shape:
//   by_store: {
//     [store_id]: {
//       items:         [...],
//       categories:    [...],
//       addons:        [...],
//       labels:        [...],
//       item_variants: [...],
//     }
//   }
//   loaded_stores: ["366", "368", ...]   // string store_ids whose catalog has been ingested
//   all_discounts: [...]                 // global, not per-store

import {
    CATALOG_LOAD_STORE,
    CATALOG_LOAD_ALL,
    CATALOG_CLEAR_STORE,
    CATALOG_CLEAR_ALL,
} from '../action-types/menu-actions';
import { CLEAR_STATE_DATA, WEB_LOGOUT } from '../action-types/session-actions';

const STORE_OFFERS = 'STORE_OFFERS';

const initState = {
    by_store: {},
    loaded_stores: [],
    all_discounts: [],
};

const emptyStore = {
    items: [],
    categories: [],
    addons: [],
    labels: [],
    item_variants: [],
};

const catalogReducer = (state = initState, action) => {
    switch (action.type) {
        case CATALOG_LOAD_STORE: {
            const sid = String(action.store_id);
            const existing = state.by_store[sid] || emptyStore;
            const next = {
                items:         action.items         !== undefined ? action.items         : existing.items,
                categories:    action.categories    !== undefined ? action.categories    : existing.categories,
                addons:        action.addons        !== undefined ? action.addons        : existing.addons,
                labels:        action.labels        !== undefined ? action.labels        : existing.labels,
                item_variants: action.item_variants !== undefined ? action.item_variants : existing.item_variants,
            };
            return {
                ...state,
                by_store: { ...state.by_store, [sid]: next },
                loaded_stores: state.loaded_stores.includes(sid)
                    ? state.loaded_stores
                    : [...state.loaded_stores, sid],
            };
        }
        case CATALOG_LOAD_ALL: {
            // Bulk replace: action.by_store is a complete { [sid]: { items, categories, ... } } map.
            // action.loaded_stores is the full list of store_ids to mark loaded.
            const incoming = action.by_store || {};
            const merged = { ...state.by_store };
            Object.keys(incoming).forEach((sid) => {
                const k = String(sid);
                const existing = merged[k] || emptyStore;
                const patch = incoming[sid] || {};
                merged[k] = {
                    items:         patch.items         !== undefined ? patch.items         : existing.items,
                    categories:    patch.categories    !== undefined ? patch.categories    : existing.categories,
                    addons:        patch.addons        !== undefined ? patch.addons        : existing.addons,
                    labels:        patch.labels        !== undefined ? patch.labels        : existing.labels,
                    item_variants: patch.item_variants !== undefined ? patch.item_variants : existing.item_variants,
                };
            });
            const incomingLoaded = (action.loaded_stores || Object.keys(incoming)).map(String);
            const loadedSet = new Set([...state.loaded_stores, ...incomingLoaded]);
            return {
                ...state,
                by_store: merged,
                loaded_stores: Array.from(loadedSet),
            };
        }
        case CATALOG_CLEAR_STORE: {
            const sid = String(action.store_id);
            const { [sid]: _drop, ...rest } = state.by_store;
            return {
                ...state,
                by_store: rest,
                loaded_stores: state.loaded_stores.filter((s) => s !== sid),
            };
        }
        case STORE_OFFERS: {
            return { ...state, all_discounts: action.storeOffer };
        }
        case WEB_LOGOUT:
        case CLEAR_STATE_DATA:
        case CATALOG_CLEAR_ALL: {
            return { ...initState };
        }
        default: {
            return state;
        }
    }
};

export default catalogReducer;
